var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCircleWarningFilled = function SvgCircleWarningFilled(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM11.9502 14.4502C11.3979 14.4502 10.9502 14.8979 10.9502 15.4502V15.5498C10.9502 16.1006 11.3955 16.5476 11.9463 16.5498H12.0459C12.3118 16.5508 12.5675 16.4464 12.7559 16.2588C12.9442 16.0712 13.0498 15.8156 13.0498 15.5498V15.4502C13.0498 14.9325 12.6565 14.5064 12.1523 14.4551L12.0498 14.4502H11.9502ZM12 7.4502C11.4477 7.4502 11 7.89791 11 8.4502V12.4502C11 13.0025 11.4477 13.4502 12 13.4502C12.5523 13.4502 13 13.0025 13 12.4502V8.4502C13 7.89791 12.5523 7.4502 12 7.4502Z",
    fill: "#282830"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleWarningFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Circle_Warning_Filled.d7e1d419.svg";
export { ForwardRef as ReactComponent };